import React from 'react'
import { Chip } from '@material-ui/core'
import Moment from 'react-moment'
import VisibilityIcon from '@material-ui/icons/Visibility'

export const getDotColumns = (onViewDetail) => [
    {
        dataField: 'dotNumber',
        text: 'DOT Number',
        formatter: (cell) => cell || '-'
    },
    {
        dataField: 'status',
        text: 'Status',
        formatter: (cell) => (
            <Chip
                label={cell || 'Unknown'}
                color={cell === 'COMPLETED' ? 'primary' : 'default'}
                size="small"
                variant="outlined"
            />
        )
    },
    {
        dataField: 'createdAt',
        text: 'Date',
        formatter: (cell) => cell ? <Moment format="MMM DD, YYYY HH:mm">{cell}</Moment> : '-'
    },
    {
        dataField: 'action',
        text: 'Action',
        formatter: (cell, row) => (
            <VisibilityIcon
                color="primary"
                style={{ cursor: 'pointer' }}
                onClick={() => onViewDetail(row.uuid)}
                titleAccess="View Details"
            />
        )
    }
]

export const getNameColumns = (onViewDetail) => [
    {
        dataField: 'name',
        text: 'Name',
        formatter: (cell) => cell || '-'
    },
    {
        dataField: 'status',
        text: 'Status',
        formatter: (cell) => (
            <Chip
                label={cell || 'Unknown'}
                color={cell === 'COMPLETED' ? 'primary' : 'default'}
                size="small"
                variant="outlined"
            />
        )
    },
    {
        dataField: 'createdAt',
        text: 'Date',
        formatter: (cell) => cell ? <Moment format="MMM DD, YYYY HH:mm">{cell}</Moment> : '-'
    },
    {
        dataField: 'action',
        text: 'Action',
        formatter: (cell, row) => (
            <VisibilityIcon
                color="primary"
                style={{ cursor: 'pointer' }}
                onClick={() => onViewDetail(row.uuid)}
                titleAccess="View Details"
            />
        )
    }
]